export class ApiUtil {

    /**
     * Dispatches an AJAX request to the internal API.
     *
     * @param {object} options – Options passed to the AJAX request.
     */
    static request(options) {
        const defaultOptions = {
            method: 'GET',
            data: {},
            dataType: 'JSON'
        };

        options = Object.assign(defaultOptions, options);

        $.ajax({
            type: options.method,
            dataType: options.dataType,
            url: '' + options.path,
            data: options.data,
            success: function (data, status, xhr) {
                return typeof options.success === 'function' ? options.success(data, status, xhr) : void 0;
            },
            error: function (xhr, error) {
                let data;
                let mime;

                if (xhr.getResponseHeader('content-type') !== undefined) {
                    mime = xhr.getResponseHeader('content-type').split(';')[0];
                }
                if (mime === 'application/json') {
                    data = JSON.parse(xhr.responseText);

                }
                return typeof options.error === 'function' ? options.error(xhr, error, data || void 0) : void 0;
            }
        });
    }

    static requestXHR(options){
        return new Promise((resolve, reject) => {
            try{
                const defaultOptions = {
                    method: 'GET',
                    dataType: 'application/json'
                };

                options = Object.assign(defaultOptions, options);
                const request = new XMLHttpRequest();
                request.open(options.method, `${options.path}`, true);
                request.overrideMimeType(options.dataType);
                request.setRequestHeader("Accept", options.dataType)
                request.setRequestHeader("Content-Type", options.dataType)

                request.onreadystatechange = () => {
                    if(request.readyState === 4){
                        if(request.status >= 200 && request.status < 400){
                            resolve(JSON.parse(request.responseText));
                        }
                        else{
                            let data;
                            let mime;

                            let contentType = request.getResponseHeader('content-type');
                            if (contentType) {
                                mime = request.getResponseHeader('content-type').split(';')[0];
                            }

                            if (mime === 'application/json') {
                                data = JSON.parse(request.responseText);
                            }

                            reject({
                                xhr: request,
                                error: request.status,
                                data: data
                            });
                        }
                    }
                }

                request.ontimeout = () => {
                    let data;
                    let mime;

                    if (request.getResponseHeader('content-type')) {
                        mime = request.getResponseHeader('content-type').split(';')[0];
                    }

                    if (mime === 'application/json') {
                        data = JSON.parse(request.responseText);
                    }

                    reject({
                        xhr: request,
                        error: request.status,
                        data: data
                    });
                }

                request.send(options.data);
            }
            catch(error){
                reject({
                    error: error.message
                });
            }
        });
    }
}
